import {
  Module,
  VuexModule,
  Mutation,
  getModule,
} from "vuex-module-decorators";

import { DryingProjectOverview } from "../../data/models/DryingProjectOverview";
import LeakDetectionProjectOverview from "../../data/models/LeakDetectionProjectOverview";

const name = "projects";

import store from "@/store";

if (store.state[name]) {
  store.unregisterModule(name);
}

@Module({ dynamic: true, namespaced: true, store, name: name })
export class ProjectsVuexModule extends VuexModule {
  runningDryingProjects: Array<DryingProjectOverview> = [];
  finishedDryingProjects: Array<DryingProjectOverview> = [];
  recentlyFinishedDryingProjects: Array<DryingProjectOverview> = [];
  archivedProjects: Array<DryingProjectOverview> = [];

  runningLeakDetectionProjects: Array<LeakDetectionProjectOverview> = [];
  finishedLeakDetectionProjects: Array<LeakDetectionProjectOverview> = [];
  recentlyFinishedLeakDetectionProjects: Array<
    LeakDetectionProjectOverview
  > = [];

  @Mutation
  setRunningDryingProjects(update: Array<DryingProjectOverview>) {
    this.runningDryingProjects = update;
  }

  @Mutation
  setArchivedProjects(update: Array<DryingProjectOverview>) {
    this.archivedProjects = update;
  }

  @Mutation
  setFinishedDryingProjects(update: Array<DryingProjectOverview>) {
    this.finishedDryingProjects = update;
  }

  @Mutation
  setRecentlyFinishedDryingProjects(update: Array<DryingProjectOverview>) {
    this.recentlyFinishedDryingProjects = update;
  }

  @Mutation
  setRunningLeakDetectionProjects(update: Array<LeakDetectionProjectOverview>) {
    this.runningLeakDetectionProjects = update;
  }

  @Mutation
  setFinishedLeakDetectionProjects(
    update: Array<LeakDetectionProjectOverview>
  ) {
    this.finishedLeakDetectionProjects = update;
  }

  @Mutation
  setRecentlyFinishedLeakDetectionProjects(
    update: Array<LeakDetectionProjectOverview>
  ) {
    this.recentlyFinishedLeakDetectionProjects = update;
  }

  @Mutation
  clear() {
    this.runningDryingProjects = [];
    this.recentlyFinishedDryingProjects = [];
    this.finishedDryingProjects = [];

    this.runningLeakDetectionProjects = [];
    this.recentlyFinishedLeakDetectionProjects = [];
    this.finishedLeakDetectionProjects = [];
    this.archivedProjects = [];
  }
}

export const ProjectsModule = getModule(ProjectsVuexModule);
